import { Link } from "react-router-dom";
import PageHeader from "@/components/site/PageHeader";
import SectionEyebrow from "@/components/site/SectionEyebrow";

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page">
      <PageHeader
        eyebrow="Privacy"
        title="Privacy Policy."
        lead="How information submitted through this website is used and protected."
        testId="privacy-page-header"
      />
      <section className="pb-16">
        <div className="wt-container">
          <article className="max-w-3xl space-y-6 wt-body">
            <div>
              <SectionEyebrow>What we collect</SectionEyebrow>
              <p className="mt-3">
                The service inquiry form on this site collects information you provide: your
                name, role, organization, email, phone (optional), needs and context, scale,
                timeline, budget range, and how you heard about Wanakee. The speaking form
                collects event-specific details. The newsletter signup collects your email and
                optional first name.
              </p>
            </div>
            <div>
              <SectionEyebrow>How we use it</SectionEyebrow>
              <p className="mt-3">
                Submissions are reviewed personally by Wanakee Trask. We use the information you
                share only to evaluate fit, follow up about your inquiry, and discuss potential
                next steps. We do not sell or rent your information.
              </p>
            </div>
            <div>
              <SectionEyebrow>How it is stored</SectionEyebrow>
              <p className="mt-3">
                Submissions are saved in a private, access-controlled database used by Wanakee
                Trask Consulting. Access is limited to Wanakee and designated team members. If a
                third-party email or scheduling tool is connected, your information may also be
                stored in that tool under their respective privacy terms.
              </p>
            </div>
            <div>
              <SectionEyebrow>Your choices</SectionEyebrow>
              <p className="mt-3">
                You can request a copy of, correction to, or deletion of the information you
                submitted by contacting us at consult@wanakeetrask.com.
              </p>
            </div>
            <div className="wt-hairline" />
            <div>
              <Link
                to="/book-consultation"
                data-testid="privacy-cta-button"
                className="wt-btn-primary"
              >
                Book a Consultation
              </Link>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
}
